import type { FC } from "react";
import { useGoalsRight } from "web_myplann/Api/Rights/RightsProvider";
import { ExpensesPage } from "web_myplann/Finances/Pages/ExpensesPage";
import { ExpensesV2Page } from "web_myplann/Finances/Pages/ExpensesV2Page";

export const ExpensesPageResolver: FC = () => {
	const hasGoalsRight = useGoalsRight();

	return hasGoalsRight ? <ExpensesV2Page /> : <ExpensesPage />;
};
